import axios from 'axios';

export const getBooks = async () => {
  const {
    data: {
      results: { books },
    },
  } = await axios.get(
    'https://api.nytimes.com/svc/books/v3/lists/current/hardcover-fiction.json?api-key=3MAAx1jQAZV75ijDLgjO2I6bFLAeP0zt'
  );

  return books;
};
